import { NavigationTabs, Tab } from "components/NavigationTabs";
import { useMemo } from "react";
import { cn } from "utils/styling";

import type { RecordFormTab, RecordFormTabOrientation } from "./types";

import { VerticalNavigationTabs } from "../VerticalNavigationTabs";

type FormTabsProps = {
  activeTabName: string;
  className?: string;
  onTabChange: (tabName: string) => void;
  orientation?: RecordFormTabOrientation;
  tabs: RecordFormTab[];
};

const toNavigationTab = (tab: RecordFormTab): Tab => ({
  disabled: tab.disabled,
  displayName: tab.label ?? tab.name,
  name: tab.name,
});

export const DynamicFormTabs = ({
  activeTabName,
  className,
  onTabChange,
  orientation = "horizontal",
  tabs,
}: FormTabsProps) => {
  const navigationTabs = useMemo(() => tabs.map(toNavigationTab), [tabs]);
  const navMenuGroups = useMemo(
    () => [{ items: tabs.map((tab) => ({ disabled: tab.disabled, id: tab.name, label: tab.label ?? tab.name })) }],
    [tabs]
  );
  const activeNavigationTab = useMemo(
    () => navigationTabs.find((tab) => tab.name === activeTabName) ?? navigationTabs[0],
    [activeTabName, navigationTabs]
  );

  const handleNavigationTabChange = (tab: Tab) => onTabChange(tab.name);

  if (!activeNavigationTab) return null;

  if (orientation === "vertical") {
    return (
      <VerticalNavigationTabs
        activeTab={activeTabName}
        className={cn("w-52 p-0", className)}
        groups={navMenuGroups}
        setActiveTab={onTabChange}
      />
    );
  }

  return (
    <NavigationTabs
      activeTab={activeNavigationTab}
      className={cn("w-full", className)}
      setActiveTab={handleNavigationTabChange}
      tabs={navigationTabs}
    />
  );
};
